import type { BoxProps } from '@chakra-ui/react';
import { Box, Flex } from '@chakra-ui/react';
import type { RefObject, Ref } from 'react';
import { type ReactNode } from 'react';

export interface MessageListProps extends Omit<BoxProps, 'onScroll'> {
  children: ReactNode;
  wrapperRef: RefObject<HTMLElement | null>;
  listRef: RefObject<HTMLElement | null>;
  topRef: RefObject<HTMLElement | null>;
  bottomRef: RefObject<HTMLElement | null>;
  messageAffix?: ReactNode;
  onScroll?: (scrollTop: number) => void;
  messageListRef: RefObject<HTMLElement | null>;
}

function MessageList({
  children,
  wrapperRef,
  listRef,
  topRef,
  bottomRef,
  messageAffix,
  onScroll,
  messageListRef,
  ...props
}: MessageListProps) {
  const handleScroll = (event: React.UIEvent<HTMLElement>) => {
    if (listRef?.current) {
      const scrollTop =
        listRef.current?.clientHeight -
        event.currentTarget.clientHeight -
        event.currentTarget.scrollTop;
      onScroll?.(scrollTop);
    }
  };

  return (
    <Box
      className="ChatPanelMessageList"
      ref={messageListRef}
      flex="1"
      minH="0"
      pos="relative"
      {...props}
    >
      <Box
        className="MessageListWrapper scrollHover"
        ref={wrapperRef}
        overflow="hidden auto"
        h="full"
        onScroll={handleScroll}
      >
        <Flex
          className="MessageList"
          ref={listRef as Ref<HTMLDivElement>}
          flexDirection="column"
          gap="20px"
          p="0 16px"
        >
          <Box ref={topRef} className="MessageIntersectionTop" h="1px" minH="1px" />
          {children}
          <Box ref={bottomRef} className="IntersectionBottom" h="1px" minH="1px" />
        </Flex>
      </Box>
      {messageAffix}
    </Box>
  );
}

const MemoizedMessageList = memo(MessageList);

export { MemoizedMessageList as MessageList };
